// 本文件 处理相关数据埋点

import moment from "moment";
import AppVersionNameMap from "@/map/AppVersionNameMap";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import GlobalStore from "@/store";
import AppVersion from "@/enum/AppVersion";
import ShopDTO from "@/dto/shop/ShopDTO";
import DataTrackEvent from "./enum/DataTrackEvent";
import { DataTrackEventParams } from "./type/DataTrackEventParamsMap";

function _gtag(...params: any[]) {
    // @ts-ignore
    if (typeof window.gtag !== "function") {
        return;
    }

    // @ts-ignore
    window.gtag(...params);
}

/**
 * 发送埋点事件
 */
export function collectEvent<T extends DataTrackEvent>(eventName: T, params?: DataTrackEventParams[T]) {
    if (import.meta.env.VITE_IS_QN) {
        return;
    }

    try {
        const cleanedParams = {};
        if (params) {
            for (const [key, value] of Object.entries(params)) {
                if (value !== undefined && value !== null) {
                    cleanedParams[key] = value;
                }
            }
        }

        _gtag("event", eventName, cleanedParams);
    } catch (e) {
        console.error(e);
    }
}

async function buildProfileSetData(currentShop: ShopDTO, globalStore: typeof GlobalStore) {
    const { type, sellerUsername, name, dateCreated, companyId } = currentShop;

    await globalStore.ensureShopSetting([currentShop.id]);

    const currentUserShopSetting = globalStore.shopSettingMapping.get(currentShop.id);

    const created_time = moment(dateCreated).format("YYYY-MM-DD HH:mm:ss");

    const allowedShopIds = globalStore.allowedShops.map(({ id }) => id);

    await globalStore.ensureShopSetting(allowedShopIds);

    const companyPremiumCount = globalStore.allowedShops.reduce((total, shop) => {
        const shopSetting = globalStore.shopSettingMapping.get(shop.id);

        return total + (shopSetting?.appVersion === AppVersion.PREMIUM ? 1 : 0);
    }, 0);

    const profileSetData = {
        user_shop_id: currentShop.id,
        user_seller_name: sellerUsername,
        user_shop_name: name,
        user_shop_type: ShopTypeNameMap[type],
        user_shop_version: AppVersionNameMap[currentUserShopSetting.appVersion],
        user_shop_created_time: created_time,
        user_company_id: companyId,
        user_shop_subscription_end_time: currentUserShopSetting.subscriptionEndTime,
        /** 租户ID总店铺数 */
        user_shops: allowedShopIds.length,
        /** 租户ID高级版店铺数 */
        user_premium_shops: companyPremiumCount,
    };

    return profileSetData;
}

/**
 * 初始化埋点服务
 * @see https://firebase.google.com/docs/analytics?hl=zh-cn
 */
export async function init(globalStore: typeof GlobalStore) {
    const currentShopId = globalStore.currentUser.shopId;
    const currentShop = globalStore.shopMapping.get(currentShopId);
    const { type, sellerUsername } = currentShop;

    const userId = `${type}|${sellerUsername}`;

    const profileSetData = await buildProfileSetData(currentShop, globalStore);

    // 配置user_id
    // @see https://developers.google.com/analytics/devguides/collection/ga4/user-id?sjid=15394878600220249284-AP&hl=zh-cn&client_type=gtag
    // 设置使用者属性
    //  @see https://support.google.com/analytics/answer/12370404?hl=zh-Hant&sjid=15394878600220249284-AP#zippy=%2Cgoogle-%E4%BB%A3%E7%A2%BC-%E7%B6%B2%E7%AB%99
    _gtag("config", "G-ZQJHZNMKZV", {
        user_id: userId,
        user_properties: profileSetData,
    });
}
